import { useEffect, useState } from "react";
import { useIsCancelledMount } from "@hooks/useIsCancelledMount";
import * as Sentry from "@sentry/react";
import { tryCatch } from "@typings/TryCatch";
import axios from "axios";

export default function useBrightcovePlayerId(): string | undefined {
  const [playerId, setPlayerId] = useState<string>("default");
  const cancelledRef = useIsCancelledMount();

  useEffect(() => {
    const callFetch = async () => {
      const { data, error } = await tryCatch(
        axios.post<string>("/_plat/api/v1/brightcove-player-id")
      );

      if (error) {
        Sentry.captureException(error);
      }

      if (!cancelledRef.current) {
        setPlayerId(data?.data || "default");
      }
    };

    callFetch();
  }, [cancelledRef]);

  return playerId;
}
